import { useId } from 'react';

interface TextFieldProps {
  label: string;
  value: string;
  onChange: (v: string) => void;
  type?: 'text' | 'email' | 'tel';
  required?: boolean;
  readOnly?: boolean;
  maxLength?: number;
  inputMode?: 'email' | 'tel';
  autoComplete?: string;
  error?: string | null;
  ariaInvalid?: boolean;
}

export function TextField({
  label,
  value,
  onChange,
  type = 'text',
  required,
  readOnly,
  maxLength,
  inputMode,
  autoComplete,
  error,
  ariaInvalid,
}: TextFieldProps) {
  const id = useId();
  const errorId = `${id}-error`;
  const hasError = Boolean(error);
  const invalid = Boolean(ariaInvalid) || hasError;

  return (
    <div className="smash-field">
      <label htmlFor={id}>{label}</label>
      <input
        id={id}
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        required={required}
        readOnly={readOnly}
        maxLength={maxLength}
        inputMode={inputMode}
        autoComplete={autoComplete}
        aria-invalid={invalid || undefined}
        aria-describedby={hasError ? errorId : undefined}
      />
      {hasError && (
        <span id={errorId} className="smash-error">
          {error}
        </span>
      )}
    </div>
  );
}
